module.exports = __webpack_public_path__ + "img/image4.6d78012d.png";